import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getAccrualPolicyCodes = (axios: IAxiosInstance) => {
  return async (params: { companyID: string; employeeID: string }) => {
    const response = await axios.noRetry.get<
      IApiResponse<
        { type: string; name: string; code: string; balance: number }[]
      >
    >(`/accrualPolicy/${params.employeeID}/codes`, {
      params: {
        companyID: params.companyID,
      },
    });

    return response.data;
  };
};
